"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var createControlTreatment = function (treatmentName) {
    var _a;
    return (_a = {},
        _a[treatmentName] = {
            treatment: "control",
        },
        _a);
};
var createControlTreatments = function (treatmentNames) {
    var treatmentsObject = {};
    treatmentNames.forEach(function (value) {
        var treatment = createControlTreatment(value);
        treatmentsObject = __assign(__assign({}, treatment), treatmentsObject);
    });
    return treatmentsObject;
};
exports.default = (function (treatmentNames) {
    return typeof treatmentNames === "string"
        ? createControlTreatment(treatmentNames)
        : createControlTreatments(treatmentNames);
});
